// api/mobileAuth.js
import axios from '@/interfaces'

// 业务线编码，作为需区分业务线的接口路径前缀（assist-助理）
const BIZ_LINE = import.meta.env.VITE_BIZ_LINE || 'assist'

/**
 * 手机号验证码登录
 * @param {Object} data - 登录参数
 * @param {string} data.mobile - 手机号
 * @param {string} data.code - 验证码
 */
export const mobileLogin = (data) => {
  return axios.post(`/${BIZ_LINE}/auth/mobile/login`, data)
    .then(res => res.data)
}
